import { useMutation } from "@tanstack/react-query";

import type { IBulkUnshareSegmentsParams } from "app/services/segments/segmentsApiService";
import SegmentsApiService from "app/services/segments/segmentsApiService";

interface UseBulkUnshareSegmentsOptions {
    onSuccess?: () => void;
    onError?: (error: Error) => void;
}

export const useBulkUnshareSegments = (options?: UseBulkUnshareSegmentsOptions) => {
    return useMutation({
        mutationFn: (params: IBulkUnshareSegmentsParams) =>
            SegmentsApiService.getInstance().unshareSegmentsBatch(params),
        onSuccess: options?.onSuccess,
        onError: options?.onError,
    });
};
